import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { TranslateService } from '../../../../services/translate.service';
import { SegProfile } from '../../../../services/template-mappers/entities/risk-register-seg-group.model';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';

/** SEG-scoped per-agent table: one row per agent with OELs, correction, ratings and adequacy. */
@Component({
    standalone: true,
    selector: 'app-seg-agents-widget',
    imports: [],
    templateUrl: './seg-agents-widget.component.html',
    styleUrl: './seg-agents-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegAgentsWidgetComponent implements OnInit {
    @Input() profiles: SegProfile[] | null = null;
    @Input() showResidual = true;
    @Input() showNotes = true;

    readonly styles = SEG_STYLES;
    labels: Record<string, string> = {};

    constructor(private translateService: TranslateService) { }

    ngOnInit(): void {
        const t = (key: string) => this.translateService.getDynamicTranslation(key);
        this.labels = {
            agent: t('Agent'), exposureBand: t('Exposure Band'), likelihood: t('Likelihood'),
            method: t('Method of assessment'), baseOel: t('Base OEL'), correctedOel: t('Corrected OEL'),
            correction: t('Correction'), samples: t('Samples'), qualitative: t('Qualitative'),
            residual: t('Residual'), controlAdequacy: t('Control Adequacy'), compliance: t('Compliance'),
            status: t('Status'), reassessment: t('Reassessment (mo)'), notes: t('Notes'), noData: t('No Data Available')
        };
    }

    public trackByIndex = trackByIndex;
}
